import { DateTimeHelper } from "src/app/core/helper/datetime.helper";

export { };
declare global {
    interface StringConstructor {
        isNullOrWhiteSpace(value?: string): boolean;
        toURLSafeBase64(value: string): string;
        fromURLSafeBase64(value: string): string;
    }

    interface String {
        toShortDateString(): string;
        toDateTimeString(): string;
        toTimeString(): string;
        toDateString(): string;
    }

    interface Number {
        hasFlag(flag: number): boolean;
        addFlag(flag: number): number;
        removeFlag(flag: number): number;
    }

    interface Array<T> {
        mapObjectsTo<U>(ctor: new (obj: T) => U): U[];
        distinct(): Array<T>;
    }
}

String.isNullOrWhiteSpace = (value?: string) => { return (value == null || !(`${value}`.trim().length > 0)) }
String.prototype.toShortDateString = function() { return DateTimeHelper.formatDateShort(this); };
String.prototype.toDateTimeString = function() { return DateTimeHelper.formatDate(this); };
String.prototype.toTimeString = function() { return DateTimeHelper.formatDate(this, true); };
String.prototype.toDateString = function() { return DateTimeHelper.formatDate(this, false, true); };
String.toURLSafeBase64 = (value: string) => {
    return btoa(value).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
};
String.fromURLSafeBase64 = (value: string) => {
    return atob(value.replace(/-/g, '+').replace(/_/g, '/').replace(/=+$/, ''));
};

Number.prototype.hasFlag = function(flag: number) {
    return (this & flag) === flag;
};

Number.prototype.addFlag = function(flag: number) {
    return this | flag;
};

Number.prototype.removeFlag = function(flag: number) {
    return this & ~flag;
};


declare global {

}

Array.prototype.mapObjectsTo = function <T, U>(ctor: new (obj: T) => U): U[] {
    return this.map(obj => new ctor(obj));
};

// add a distinct() property to the Array prototype to remove duplicates
Array.prototype.distinct = function () {
    return this.filter((value, index, self) => self.indexOf(value) === index);
}





// add a date time format function to the Date object using the dateTimehelper format date function
declare global {
    interface Date {
        toDisplayString(): string;
    }
}

Date.prototype.toDisplayString = function() {
    return DateTimeHelper.formatDate(this, false, true);
}